import {Controller} from "stimulus";

export default class extends Controller {
    static targets = ["tabHeader", "tabContent", "tabNav"];

    connect() {
        if (this.tabHeaderTargets.length > 1) {
            this.tabNavTarget.classList.remove("hidden");
            this.setSelectedTab(this.tabHeaderTargets[0]);
        } else {
            this.tabContentTargets[0].classList.remove("hidden");
        }
    }

    showTab(e) {
        e.preventDefault();
        this.setSelectedTab(e.target);
    }

    setSelectedTab(selectedTabHeader) {
        let selectedPaymentMethodType = selectedTabHeader.attributes.getNamedItem("data-payment-method-type").value;
        this.tabHeaderTargets.forEach((tabHeader) => {

            if (tabHeader === selectedTabHeader) {
                tabHeader.classList.add("border-brand");
                tabHeader.classList.add("font-bold");

            } else {
                tabHeader.classList.remove("border-brand");
                tabHeader.classList.remove("font-bold");
            }
        });

        this.tabContentTargets.forEach((tabContent) => {
            let paymentMethodType = tabContent.attributes.getNamedItem("data-payment-method-type").value;
            if (paymentMethodType === selectedPaymentMethodType) {
                tabContent.classList.remove("hidden");
            } else {
                tabContent.classList.add("hidden");
            }
        });
    }
  }
  